import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from '../Components/AuthContext';

const DashboardContent = ({ setActiveLink }) => {

  const { token } = useContext(AuthContext); // Get the token from AuthContext

  const [dashboardData, setDashboardData] = useState({
    currentOrder: 0,
    historyOrder: 0,
    savedItems: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch the dashboard data on component mount
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(
          'https://backend.printtrio.co.uk/api/profile/dashboard-count',
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setDashboardData(response.data.data); // Set dashboard data from API response
        } else {
          setError('Failed to fetch data');
        }
      } catch (err) {
        setError('An error occurred while fetching dashboard data');
      } finally {
        setLoading(false); // Set loading to false after the fetch is done
      }
    };

    if (token) {
      fetchDashboardData(); // Fetch data only if token exists
    }
  }, [token]);



  if (error) {
    return <p className="text-red-500">{error}</p>; // Display error message if any
  }

  return (
    <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%]">
      {/* Statistics Cards */}
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Current Orders */}
        <div className="bg-pink-50 border border-pink-500 rounded-lg p-6 text-center cursor-pointer"
        onClick={() => setActiveLink('Current Orders')}
        >
          <p className="text-pink-500 text-5xl font-semibold">{dashboardData.currentOrder}</p>
          <p className="text-gray-600 mt-2 font-medium">Current Orders</p>
        </div>

        {/* Order History */}
        <div className="bg-pink-50 border border-pink-500 rounded-lg p-6 text-center cursor-pointer"
        onClick={() => setActiveLink('History')}
        >
          <p className="text-pink-500 text-5xl font-semibold">{dashboardData.historyOrder}</p>
          <p className="text-gray-600 mt-2 font-medium">Order History</p>
        </div>

        {/* Saved Items */}
        <div className="bg-pink-50 border border-pink-500 rounded-lg p-6 text-center cursor-pointer"
        onClick={() => setActiveLink('Saved Items')}
        >
          <p className="text-pink-500 text-5xl font-semibold">{dashboardData.savedItems}</p>
          <p className="text-gray-600 mt-2 font-medium">Saved Items</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
